import View from "../account/views/FindQuoteInvoiceFormView";
import components from "./components.js";
components.define("js-findquoteinvoice-form", View);